<script type="application/ld+json">
	{     
		"@context": "http://schema.org",
		"@type": "BreadcrumbList",
		"itemListElement": [
		{
		  "@type": "ListItem",
		  "position": 1,
		  "item": {
		    "@id": "https://www.protectt.ai/",
		    "name": "Home"
		  }
		},{
		  "@type": "ListItem",
		  "position": 2,
		  "item": {
		    "@id": "https://www.protectt.ai/about-us",
		    "name": "About Us"
		  }
		}		]
	}
	</script>
<!-- Breadcrumbs -->
<div class="breadcrumbs">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <ul class="breadcrumbsul">
                    <li><a href="#">Home</a></li>
                    <li>></li>
                    <li>About Us</li>
                </ul>
            </div>
        </div>
    </div>
</div>
<div style="background: linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)),url('assets/images/header/header-1.webp'); background-position: right; background-size: cover;"
    class="section-agency-benefit section-pt section-pb-60 d-none d-md-block">
    <div class="container subbanner">
        <div class="row align-items-center">
            <div class="col-lg-8 col-md-8 col-xl-8">
                <div class="d-none d-sm-block">
                    <h1 id="bnr-heading">{{heading}} </h1>
                    <h2 id="bnr-subheading"> {{subheading}}</h2>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Banner For Mobile -->

<div style="background: linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)),url('assets/images/header/header-mobile.webp'); background-position: top; background-size: cover;"
    class="section-agency-benefit section-pt section-pb-60 d-block d-md-none" (window:resize)="onResize($event)">
    <div class="container subbanner">
        <div class="row align-items-center" *ngIf="innerWidth > 768">
            <div class="col-lg-12">
                <div class="mt-50">
                    <!-- header background -->
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Banner Heading For Mobile -->

<div class="container d-block d-md-none" (window:resize)="onResize($event)">
    <div class="row">
        <div class="col-12">
            <div class="mt-15 mb-15 text-center" *ngIf="innerWidth <= 768">
                <h1 id="bnr-heading">{{heading}}</h1>
                <h4 id="bnr-subheading">{{subheading}}</h4>
            </div>
        </div>
    </div>
</div>

<div class="container">
    <div class="row text-center newcard">
        <div class=" col-md-4 text-center" routerLink="/appprotectt" style="opacity: 1;">
            <div class="card content-box unheight aboutus-pass cursor-pointer">
                <div class="card-body">
                    <img alt="Real-time information" title="Real-time information"
                        class="finbyz-icon img-responsive og_image_url"
                        src="assets/images/serviece/mobile-app-security.png">
                    <h4 class="card-title mt-4">Mobile App Security</h4>
                    <p class="content-box-sub">We secure your business Mobile applications through cutting edge Runtime
                        Application Self Protection </p>
                </div>
            </div>
        </div>
        <div class="col-md-4" routerLink="/appbind" style="opacity: 1;">
            <div class="card content-box unheight text-center aboutus-pass cursor-pointer">
                <div class="card-body">
                    <img alt="Higher Productivity" title="Higher Productivity" class="finbyz-icon img-responsive"
                        src="assets/images/serviece/app-bind.png">
                    <h4 class="card-title mt-4">AppBind - Zero Trust Device Binding for Mobile Banking Apps</h4>
                    <p class="content-box-sub">Authenticate and monitor every user journey at all time. </p>
                </div>
            </div>
        </div>
        <div class="col-md-4" routerLink="/rbi-digital-payment-security-control-solution" style="opacity: 1;">
            <div class="card content-box unheight text-center aboutus-pass cursor-pointer">
                <div class="card-body">
                    <img alt="Improved Collaboration" title="Improved Collaboration" class="finbyz-icon img-responsive"
                        src="assets/images/serviece/rbi-digital-payment-security.png">
                    <h4 class="card-title mt-4">RBI Digital Payment Security Control Solution</h4>
                    <p class="content-box-sub">AppProtectt – An armor against cyber threats.</p>
                </div>
            </div>
        </div>
    </div>
    <div class="row newcard">
        <div class="col-md-2"></div>
        <div class="col-md-4 text-center" routerLink="/mprotectt" style="opacity: 1;">
            <div class="card content-box unheight aboutus-pass cursor-pointer">
                <div class="card-body">
                    <img alt="Real-time information" title="Real-time information" class="finbyz-icon img-responsive"
                        src="assets/images/serviece/mobile-device-security.png">
                    <h4 class="card-title mt-4">Mobile Device Security (Personal)</h4>
                    <p class="content-box-sub">We understand your mobile knows everything about you, keep your privacy
                        safe.
                    </p>
                </div>
            </div>
        </div>
        <div class="col-md-4" routerLink="/cyber-lab-services" style="opacity: 1;">
            <div class="card content-box unheight text-center aboutus-pass cursor-pointer">
                <div class="card-body">
                    <img alt="Higher Productivity" title="Higher Productivity" class="finbyz-icon img-responsive"
                        src="assets/images/serviece/cyber-lab-service.png">
                    <h4 class="card-title mt-4">Cyber Lab Services</h4>
                    <p class="content-box-sub">Get specialized cyber security and audit services from a pool of highly
                        talented protectors.</p>
                </div>
            </div>
        </div>
        <div class="col-md-2"></div>
    </div>
</div>

<!-- Start Introduction -->
<pre></pre>
<!-- End Introduction -->

<!-- Start Agency Benefits Area -->
<div class="section-agency-benefit bg-gray mt-2 section-pb-60">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-12">
                <div class="agency-benefits">
                    <div class="content">
                        <p>
                            "Protectt.ai is India’s first mobile security platform building awareness & providing
                            solutions for mobile app, device & transaction security. Our innovative mobile threat
                            defence security with a state-of-the-art security cloud is constantly scanning the digital
                            horizons for emerging mobile threats in today’s rapidly evolving world.
                        </p>
                        <p>
                            Protectt.ai's solutions can be tailored for any industry, across large enterprises,
                            start-ups, and for individual users too. In a shorter period of time, Protectt.ai has
                            acquired India’s leading enterprises across Banking, Insurance, Finance, FinTech and EdTech
                            to protect their Mobile Apps & thousands of individuals to protect their mobile devices. We
                            are leading the path in creating a market that helps each organisation operate in a safe
                            digital environment and facilitates building a #Atmanirbhar Bharat.
                        </p>
                        <p>
                            At Protectt.ai, we are driven by deep passion, unparalleled enthusiasm and a dedicated drive
                            to make a profound impact to secure Mobile Apps, Devices & transactions."
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- End Agency Benefits Area -->
<!-- Start Agency Benefits Area -->
<!-- End Agency Benefits Area -->

<!-- Start Agency Benefits Area -->
<section #destination>
    <div class="section-agency-benefit section-pb-60">
        <div class="container">
            <div class="section-title text-center">
                <h2>Our Offices</h2>
            </div>
            <div class="container">
                <div class="row aboutus-card justify-content-center align-items-center">
                    <div class="card">

                        <div class="card__img">
                            <img src="assets/images/about/gurugram.webp" alt="gurugram" />
                        </div>
                        <div class="card__text">
                            <h2 style="margin-top: 5px;">
                                <a style="text-decoration: none; color: #1A3F6E;"
                                    href="https://goo.gl/maps/zM2Aongw69v3AQvr9" target="_blank"
                                    rel="noopener noreferrer">
                                    Gurugram
                                </a>
                            </h2>
                            <p style="color: #D82B27; font-size: 16px;">
                                <a style="text-decoration: none; color: #D82B27;"
                                    href="https://goo.gl/maps/zM2Aongw69v3AQvr9" target="_blank"
                                    rel="noopener noreferrer">
                                    Regional Office
                                </a>
                            </p>
                            <blockquote style="margin-bottom: 35px;">
                                <a style="text-decoration: none; color: #1A3F6E;"
                                    href="https://goo.gl/maps/zM2Aongw69v3AQvr9" target="_blank"
                                    rel="noopener noreferrer">
                                    AWFIS, 3rd Floor<br />
                                    Tower B, Unitech Cyber Park, Sector 39,<br />
                                    Gurugram, Haryana - 122002
                                </a>
                            </blockquote>
                            <blockquote></blockquote>
                        </div>
                    </div>

                    <div class="card">
                        <div class="card__img">
                            <img src="assets/images/about/mumbai.webp" alt="mumbai" />
                        </div>
                        <div class="card__text">
                            <h2>
                                <a style="text-decoration: none; color: #1A3F6E;"
                                    href="https://maps.app.goo.gl/yDnCVm44zMtrbHLa6" target="_blank"
                                    rel="noopener noreferrer">
                                    Mumbai
                                </a>
                            </h2>
                            <p style="color: #D82B27; font-size: 16px;">
                                <a style="text-decoration: none; color: #D82B27;"
                                    href="https://maps.app.goo.gl/yDnCVm44zMtrbHLa6" target="_blank"
                                    rel="noopener noreferrer">
                                    Corporate Office
                                </a>
                            </p>
                            <blockquote>
                                <a style="text-decoration: none; color: #1A3F6E;"
                                    href="https://maps.app.goo.gl/yDnCVm44zMtrbHLa6" target="_blank"
                                    rel="noopener noreferrer">
                                    AWFIS, 6th floor,<br />
                                    Vaman Techno Center, Makwana Rd,<br /> Marol, Andheri East,<br />
                                    Mumbai, Maharashtra 400059
                                </a>
                            </blockquote>
                        </div>
                    </div>

                    <div class="card">
                        <div class="card__img">
                            <img src="assets/images/about/chennai.webp" alt="chennai" />
                        </div>
                        <div class="card__text">
                            <h2>
                                <a style="text-decoration: none; color: #1A3F6E;"
                                    href="https://goo.gl/maps/sEHkK3ytMa7sxUABA" target="_blank"
                                    rel="noopener noreferrer">Chennai
                                </a>
                            </h2>
                            <p style="color: #D82B27; font-size: 16px;">
                                <a style="text-decoration: none; color: #D82B27;"
                                    href="https://goo.gl/maps/sEHkK3ytMa7sxUABA" target="_blank"
                                    rel="noopener noreferrer">Product Innovation Center
                                </a>
                            </p>
                            <blockquote>
                                <a style="text-decoration: none; color: #1A3F6E;"
                                    href="https://goo.gl/maps/sEHkK3ytMa7sxUABA" target="_blank"
                                    rel="noopener noreferrer">
                                    AWFIS, 3rd floor, No: 143, 1,<br />
                                    Uthamar Gandhi Rd, Thousand Lights West, Nungambakkam,<br />
                                    Chennai, Tamil Nadu - 600034<br />
                                </a>
                            </blockquote>
                        </div>
                    </div>

                    <div class="col-lg-12 text-center mt-50">
                        <a class="btn-rectangle-1 btn-transparent btn mt-1" routerLink="/industry-news">Industry
                            News</a>
                        <a class="btn-rectangle-1 btn-transparent btn mt-1" routerLink="/blogs">Blogs</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- End Agency Benefits Area -->
<!-- Start Button -->
<!-- End Buttons -->